<template>
  <div class="c_sort"
    :class="{['c_sort_active' + activeClass]: showSortPop}"
    role='button'
    aria-label='filter'
    tabIndex="0"
    @click="toggleSorPop">
    <i class="icon-sort"></i>
    <ul
      class="c_sort_list g_pop"
      :class="{'g_pop_active': showSortPop}"
      role='menubar'>
      <li
        class="item"
        @click.stop="changeSort(option.key)"
        :class="{'item_select': sortBy === option.key}"
        v-for="option in options"
        v-show="!option.hide"
        :key="option.key">{{option.name}}</li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    sortBy: String,
    changeSortBy: Function,
    options: {
      type: Array,
      default: function() {
        return [{ name: this.$t('sortList.byTime'), key: 'time' }, { name: this.$t('sortList.byName'), key: 'name' }, { name: this.$t('sortList.byNum'), key: 'num' }]
      },
    },
    activeClass: {
      tyoe: String,
      default: '',
    },
  },
  data() {
    return {
      showSortPop: false,
    }
  },
  methods: {
    toggleSorPop() {
      this.showSortPop = !this.showSortPop
      if (this.showSortPop) {
        setTimeout(() => {
          document.addEventListener('click', this.toggleSorPop, false)
        }, 0)
      } else {
        document.removeEventListener('click', this.toggleSorPop)
      }
    },
    changeSort(sortBy) {
      if (!sortBy) return
      if (this.sortBy === sortBy) return
      this.changeSortBy(sortBy)
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/scss//mixin.scss';

.c_sort{
  position: relative;
}
.c_sort_list{
  left: -100%;
  width: 113px;
  padding:8px 0;
  .item {
    line-height: 20px;
    height: 20px;
    text-align: left;
    padding: 0 10px;
    padding-left: 20px;
  }
  .item_select{
    padding-left: 10px;
  }
  .item_select:before{
    content:'';
    display: inline-block;
    height: 5px;
    width: 5px;
    background: #F96A6A;
    border-radius: 999px;
    margin-right: 5px;
    line-height: 20px;
    vertical-align: middle;
  }
}
.c_sort_active{
  background: #D9D9D9;
}
</style>
